import * as React from 'react';
import { connect } from "react-redux";

import {
  ModalLogin,
  ModalRegister
} from "~/components/account";

// actions
import {
  logout
} from "~/actions/account";

interface INavibar { account: any, dispatch: Function }
class Navibar extends React.Component<INavibar, any> {
  constructor(props: INavibar) {
    super(props);
    this.checkAuthen(this.props.account.isLogged);
  }

  modalProps = { handleShow: Function, handleClose: Function };
  modalLoginRef = { ...this.modalProps }
  modalRegisterRef = { ...this.modalProps }

  componentWillReceiveProps(nextProps: INavibar) {
    this.checkAuthen(nextProps.account.isLogged);
  }

  checkAuthen = (isLogged: boolean) => {
    if (isLogged) {
      this.modalLoginRef.handleClose();
      this.modalRegisterRef.handleClose();
    }
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll, { passive: true })
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll = () => {
    const numSet = 600;
    window.onscroll = function () { myFunction() };
    function myFunction() {
      var nav = document.getElementById('nav-bg');
      if (window.scrollY > numSet && nav) {
        nav.classList.add('bg');
      } else if (nav) {
        nav.classList.remove('bg');
      }
    }
  }

  onClickLogin = () => {
    this.modalLoginRef.handleShow();
  }
  onClickRegister = () => {
    this.modalRegisterRef.handleShow();
  }

  onClickLogOut = () => {
    this.props.dispatch(logout());
  }

  getStatusHeader = () => {
    if (this.props.account.isLogged) {
      return (
        <li>
          <span className="Navibar__user">
            { this.props.account.fullname }
            <span onClick={this.onClickLogOut} className="Navibar__user--btn-logout" role="button">
              <i className="fas fa-sign-out-alt" />
            </span>
          </span>
        </li>
      )
    }
    return (
      [
        <li key="0"><a role="button" onClick={this.onClickLogin}>SIGN IN</a></li>, 
        <li key="1" className='create-account'>
          <button onClick={this.onClickRegister}>CREATE ACCOUNT</button>
        </li>
      ]
    )
  }

  render() {
    return (
      <div className="Navibar clearfix">
        <nav className="navbar navbar-fixed-top clearfix" id='nav-bg'>
          <div className="container">
            <div className="col-md-3">
              <div className="navbar-header">
                <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbar" aria-expanded="false" aria-controls="navbar">
                  <span className="sr-only">Toggle navigation</span>
                  <span className="icon-bar"></span>
                  <span className="icon-bar"></span>
                  <span className="icon-bar"></span>
                </button>
                <a className="navbar-brand" href="/"><span className='txt-rock'>Rock </span><span className='txt-the-JMV'>the JVM</span></a>
              </div>
            </div>
            <div className="col-md-9">
              <div id="navbar" className="navbar-collapse collapse">
                <ul className="nav navbar-nav navbar-right">
                  <li><a href="">ABOUT US</a></li>
                  <li><a href="">HOW IT WORKS?</a></li>
                  {
                    this.getStatusHeader()
                  }
                </ul>
              </div>
            </div>
          </div>
        </nav>
        <ModalLogin initRef={(ref: any) => this.modalLoginRef = ref} />
        <ModalRegister initRef={(ref: any) => this.modalRegisterRef = ref} />
      </div>
    );
  }
}


const mapStateToProps = (store: any) => {
  return {
    account: store.session.userAuth
  }
}

export default connect(mapStateToProps)(Navibar);



// WEBPACK FOOTER //
// ./src/components/homepage/Navibar.tsx